import React, { useState } from "react";
import { PageContainer } from "../components/Container/PageContainer";
import { FriendsInteractionSection } from "../components/LifetimeAnalytic/FriendsInteractionSection";
import { TopFriendsSection } from "../components/LifetimeAnalytic/TopFriendsSection";
import { FriendConversationModal } from "../components/modal/FriendConversationModal";
import { useFriendsInteractionData } from "../hooks/useThreadsSelector";

const FriendsInteraction = () => {
  const { repliesByUser } = useFriendsInteractionData();
  
  const [opened, setOpened] = useState(false);
  const [selectedThreads, setSelectedThreads] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  // 특정 사용자와의 대화 데이터 찾기 및 그루핑
  const getUserConversations = (username) => {
    const userInteraction = repliesByUser.find(
      (user) => user.username === username
    );
    if (!userInteraction || !userInteraction.conversations) {
      return [];
    }
    
    // 대화를 원글별로 그루핑
    const grouped = userInteraction.conversations.reduce(
      (acc, conversation) => {
        const threadId =
          conversation.threadId || conversation.threadText || "unknown";
        if (!acc[threadId]) {
          acc[threadId] = {
            threadText: conversation.threadText,
            conversations: [],
          };
        }
        acc[threadId].conversations.push(conversation);
        return acc;
      },
      {}
    );
    
    // 각 그룹 내에서 시간순 정렬 후 그룹을 배열로 변환
    return Object.values(grouped)
      .map((group) => ({
        ...group,
        conversations: group.conversations.sort(
          (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
        ),
      }))
      .sort((a, b) => {
        // 각 그룹의 가장 최신 댓글 기준으로 정렬
        const latestA = Math.max(
          ...a.conversations.map((c) => new Date(c.timestamp))
        );
        const latestB = Math.max(
          ...b.conversations.map((c) => new Date(c.timestamp))
        );
        return latestB - latestA;
      });
  };

  const handleUserClick = (username) => {
    const userConversationGroups = getUserConversations(username);
    
    setSelectedThreads(userConversationGroups);
    setSelectedUser(username);
    setOpened(true);
  };

  return (
    <PageContainer>
      <TopFriendsSection onUserClick={handleUserClick} />
      <FriendsInteractionSection onUserClick={handleUserClick} />

      {/* 친구 대화 모달 */}
      <FriendConversationModal
        opened={opened}
        onClose={() => setOpened(false)}
        selectedUser={selectedUser}
        selectedThreads={selectedThreads}
      />
    </PageContainer>
  );
};

export default FriendsInteraction; 